import React, { useEffect, useState } from "react";
import "../../style/Questions.scss";
import classes from "../../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../../Images/UpdatedDexter-call.svg";
import {
  ROUTE_INVESTMENT_PROFILE,
  ROUTE_PORT_FOLIO,
  ROUTE_RESIDENTIAL_STATUS,
  ROUTE_HOLD_INVESTMENT,
  ROUTE_DXTER_SCANNING,
  ROUTE_MOBILE_VERIFICATION,
} from "../../Routes";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateDependants } from "../../Store/dexterrPortfolio/actions";
import Toast from "../../Components/ToastMsg/Toast";
import { ToastContainer } from "react-toastify";
import axios from "../../libs/axiosConfig";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import { selectPhoneNumber } from "../../Store/MobileSlice";

const FinanciallyDepended = () => {
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const dispatch = useDispatch();
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const refreshToken = useSelector(selectRefreshToken);
  console.log("Refresh Token:", refreshToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const [isLoading, setIsLoading] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  // const HandleBack = () => {
  //   Navigate(ROUTE_INVESTMENT_PROFILE);
  // };
  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);
  const handleBoxClick = (index) => {
    if (selectedBoxes.includes(index)) {
      setSelectedBoxes(selectedBoxes.filter((box) => box !== index));
    } else {
      setSelectedBoxes([...selectedBoxes, index]);
      // Toast.success("Selected")
    }
  };

  const isSelected = (index) => {
    return selectedBoxes.includes(index);
  };

  const options = [
    {
      heading: "Kid (s)",
    },
    {
      heading: "Spouse",
    },
    {
      heading: "Parents",
    },
    {
      heading: "Others",
    },
    {
      heading: "No dependents",
    },
  ];

  const getApiFormat = (selectedOption) => {
    switch (selectedOption) {
      case "Kid (s)":
        return "kids";
      case "Spouse":
        return "spouse";
      case "Parents":
        return "parents";
      case "Others":
        return "others";
      case "No dependents":
        return "no_dependants";

      default:
        return "";
    }
  };
  const HandleSubmit = async () => {
    try {
      if (selectedBoxes.length > 0) {
        setApiCallsInProgress(apiCallsInProgress + 1);

        const selectedOptions = selectedBoxes.map((index) => options[index]);
        const financial_dependant = selectedOptions.map((option) => option.heading);

        const apiPayload = {
          dexterrCustomerBasicQuestions: {
            financial_dependant: financial_dependant.join(','),
            mobile_no: phoneNumber,
            request_type: "post",
            country_code: "+91",
          },
        };


        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storedToken}`,
          // RefreshToken: refreshToken,
        };

        const response = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          apiPayload,
          {
            headers: headers,
          }
        );

        if (response.status === 200) {
          dispatch(updateDependants(selectedOptions.heading));
          // Toast.success("Data submitted successfully");
          const requestBody = {
            dexterrCustomerBasicQuestions: {
              mobile_no: phoneNumber,
              request_type: "get",
              country_code: "+91",
            }
          };

          const secondApiResponse = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody,
            {
              headers: headers,
            }
          );

          if (secondApiResponse.status === 200) {
            const secondApiData = secondApiResponse.data;
            console.log("Second API Data:", secondApiData);
            setApiCallsInProgress(apiCallsInProgress - 1);

            if (
              secondApiData.data.resident !== "" &&
              secondApiData.data.investment_years !== "" &&
              secondApiData.data.investment_profile !== "" &&
              secondApiData.data.financial_dependant !== "" &&
              secondApiData.data.temporary_drop_percentage_portfolio !== "" &&
              secondApiData.data.temporary_drop_percentage_portfolio !== ""
            ) {
              Navigate(ROUTE_DXTER_SCANNING, {
                state: { tokens: { accessToken: storedToken, refreshToken } },
              });
            } else {
              if (
                secondApiData.data.temporary_drop_percentage_portfolio === ""
              ) {
                Navigate(ROUTE_PORT_FOLIO);
              } else if (secondApiData.data.investment_years === "") {
                console.log("Navigating to ROUTE_HOLD_INVESTMENT");
                Navigate(ROUTE_HOLD_INVESTMENT);
              } else if (secondApiData.data.investment_profile === "") {
                console.log("Navigating to ROUTE_INVESTMENT_PROFILE");
                Navigate(ROUTE_INVESTMENT_PROFILE);
              } else if (secondApiData.data.resident === "") {
                console.log("Navigating to ROUTE_RESIDENTIAL_STATUS");
                Navigate(ROUTE_RESIDENTIAL_STATUS);
              } else {
                console.log("Navigation failed. Check conditions and routes.");
              }
            }
          } else {
            Toast.error(
              secondApiResponse.data.message +
              " " +
              secondApiResponse.data.errorMessage
            );
            setApiCallsInProgress(apiCallsInProgress - 1);

          }
        } else {
          Toast.error(response.data.message + " " + response.data.errorMessage);
        }
      } else {
        setApiCallsInProgress(apiCallsInProgress - 1);

        Toast.error("Please select an option before proceeding.");
      }
    } catch (error) {
      console.error("Error:", error);
      Toast.error(
        error.response.data.errorMessage +
        " " +
        error.response.data.message || "Error"
      );
    }
  };
  const HandleBack = () => {
    Navigate(-1)
  };

  // const handleLogoutConfirm = () => {
  //   Navigate(ROUTE_MOBILE_VERIFICATION);
  // };
  return (
    <div className="question-main-container">
      <div className="KYC_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Header_Dexter_logo">
          <img alt="" src={NewDexterLogo} className={classes.DexterLogo} />
        </div>
      </div>
      <div className="Questions_Container">
        <p className="Question_Heading_text">
          How many people depend on <br />
          you financially?{" "}
        </p>
        <span className="Question_Sub_heading">
          Select multiple if applicable{" "}
        </span>
        <div className="Select_Option_Container">
          {options.map((option, index) => (
            <div
              key={index}
              className="Select_Box"
              style={{
                background: isSelected(index)
                  ? "linear-gradient(90deg, rgba(0, 0, 0, 0.2) -1.5%, rgba(1, 61, 196, 0.2) 101.05%)"
                  : "",
              }}
              onClick={() => handleBoxClick(index)}
            >
              <p className="Option_Label">
                <span className="Label_Heading_Text">
                  {option.heading}
                </span>
              </p>
              <button
                className="Select_Button"
                style={{
                  background: isSelected(index) ? "#013DC4" : "",
                }}
              />
            </div>
          ))}
        </div>
        <button className="Next_button" onClick={HandleSubmit}>
          Next
        </button>
      </div>
      {isLoading && (
        <div className="overlay">
          <div className="loading_text">Please Wait...</div>
        </div>
      )}
      <ToastContainer />

      {/* <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      /> */}


    </div>
  );
};

export default FinanciallyDepended;
